export default {
  id_nav_title: "身分認證",
  basic_nav_title: "基礎資訊",
  work_nav_title: "工作資訊",
  other_nav_title: "其他資訊",
  basic_Fill_in_the_information_below: "請認真填寫下方資料",
  basic_education: "教育程度",
  basic_personal_information: "個人資料",
  basic_other_contact: "其他聯絡方式",
  basic_select_education: "請選擇教育程度",
  basic_marriage: "婚姻狀況",
  basic_select_marriage: "請選擇婚姻狀況",
  basic_children_num: "子女數",
  basic_select_children_num: "請選擇子女數",
  basic_house_type: "房屋類型",
  basic_select_house_type: "請選擇房屋類型",
  basic_stay_length: "居住時間",
  basic_select_stay_length: "請選擇居住時間",
  basic_living_area: "居住地區",
  basic_select_living_area: "請選擇居住地區",
  basic_address_info: "詳細地址",
  basic_p_address_info: "請輸入詳細地址",
  basic_p_line: "請輸入LINE",
  basic_Facebook: "Facebook",
  basic_p_Facebook: "請輸入Facebook連結",
  basic_zalo: "zalo",
  basic_p_zalo: "請輸入Zalo帳號",
  basic_submit: "下一步",
  basic_ok: "填寫完成"
}